import { Box } from "@mui/material";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { AccountsandFinanceurl } from "../../../../config";
import { AllAccountTransfersView, allAccountTransfersView } from "../../../../data/Axios/queries";
import AccountsTransfersForm from "./form";
import { AccountTransfersColumns } from "../../../../data/DynamicTable/AccountsColumns";

const base_url = AccountsandFinanceurl.uri;

const actions = {
  entity: "Accounts Transfers",
  isSubRight: true,

  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },

  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },

  approveAccountTransafer: {
    key: "APPROVE",
    button_name: "Approve",
    Show_Button: true,
     permission: "hasNoPermission",
         roleGroupId: [1, 2, 3, 4],
  },

  cancelAccountTransafer: {
    key: "CANCEL",
    button_name: "Cancel",
    Show_Button: true,
     permission: "hasNoPermission",
         roleGroupId: [1, 2, 3, 4],
  },

  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

  showStatus: true,
};

function AccountsTransfersTable() {
  return (
    <Box m="2px">
      <DynamicTable
        title="Accounts Transfers"
        subtitle="Create, view, approve or cancel transfers"
        columns={AccountTransfersColumns} 
        FormComponent={AccountsTransfersForm}
        query={allAccountTransfersView}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}

export default AccountsTransfersTable;
